<script>
  import Swiper from './Swiper.vue'
  import SwiperItem from './SwiperItem.vue'
  export default {
    Swiper,
    SwiperItem
  }
</script>



// WEBPACK FOOTER //
// index.vue?24225d69